import React from 'react';
import { classNames } from '../../../utils/classNames/classNames.esm.js';
import 'tslib';
import '@popperjs/core';
import { TruncateText } from '../../TruncateText/TruncateText.esm.js';
import { StatusIcon } from './StatusIcon.esm.js';

var rootClassName = classNames("tw-box-border tw-flex tw-space-x-1 tw-items-center tw-justify-between", "tw-w-full tw-truncate tw-py-2 tw-pr-2 tw-pl-4", "tw-border-solid tw-border-0 tw-border-b tw-border-gray-300", "tw-uppercase tw-text-left tw-text-2xs tw-text-secondary", "tw-bg-gray-100 dark:tw-bg-gray-900");
function ModalWizardNavHeading(_a) {
    var children = _a.children, status = _a.status;
    return (React.createElement("li", { className: rootClassName, "data-testid": "wizard-nav-heading" },
        React.createElement(TruncateText, { addClassName: "tw-flex-shrink tw-text-default dark:tw-text-dark-bg" }, children),
        React.createElement(StatusIcon, { status: status })));
}

export { ModalWizardNavHeading };
//# sourceMappingURL=ModalWizardNavHeading.esm.js.map
